<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {
  mounted() {

  	//var urlParams = new URLSearchParams(window.location.search);
  	//var client = urlParams.get('host');
  	
    //let $this = this.$store;
    //$this.dispatch("clients/getCurrentClient", client)
    //setTimeout(function() {
    //	$this.dispatch("settings/getSettings", $this.state.clients.current.id);
    //}, 2500);

    //this.runPoller();
  },
  methods: {
    runPoller: function () {
      setInterval(() => {
        let $this = this.$store;
        $this.dispatch("users/isLoggedIn").then(() => {
          if(!$this.state.users.isLoggedIn){
            $this.dispatch("authentication/logout");
          }
        })
      }, 10000);
    }
  }
}
</script>
